module.exports = __webpack_public_path__ + "img/bottom_icon_pick.56f54069.svg";